import React, { useMemo, useState } from 'react';
import { Box, FormHelperText } from '@material-ui/core';
import { useSelector, useLocation } from 'umi';
import { Controller } from 'react-hook-form';
import {
  TextFieldCom,
  UploadImageCom,
  RadioFieldCom,
  CheckBoxFieldCom,
} from './FormType';
import DialogMl from './Dialog';
import { OPT_DETAIL } from '@/constants';
import {
  DEFAULT_RADIO,
  CONTROL_RULES,
  NEW_MEMBER_CONTROL_RULES,
} from '../constants';
import GoodsShelfContent from './GoodsShelfContent/GoodsShelfContent';

export default ({ control, setValue, getValues, errors }) => {
  const { defaultValue } = useSelector(
    (state) => state.managementGoodsShelfForm,
  );
  const location = useLocation();
  const { query } = location;
  const { id, opt } = query;
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState();
  //当前视口宽度
  const clientWidth = document.body.clientWidth;
  //当前视口高度
  const clientHeight = document.body.clientHeight;

  const handlePreviewClose = () => {
    setPreviewUrl();
    setPreviewOpen(false);
  };
  //点击图片预览
  const handlePreview = (imgUrl) => {
    setPreviewUrl(imgUrl);
    setPreviewOpen(true);
  };

  useMemo(() => {
    if (defaultValue && id) {
      for (let v in defaultValue) {
        if (v === 'monthlyExchangeNum') {
          defaultValue[v] && setValue('rule', ['1']);
          setValue('monthlyExchangeNum', defaultValue[v]);
        } else if (v === 'memberThresholdDay') {
          defaultValue[v] && setValue('newMemberRule', ['1']);
          setValue('memberThresholdDay', defaultValue[v]);
        } else if (v === 'memberStartDate' || v === 'memberEndDate') {
          setValue('date', {
            startDate: defaultValue?.memberStartDate,
            endDate: defaultValue?.memberEndDate,
          });
        } else {
          setValue(v, defaultValue[v]);
        }
      }
    }
  }, [defaultValue, setValue, id]);
  return (
    <Box display="flex" flexDirection="column">
      <Box
        sx={{
          color: '#212121',
          fontSize: '18px',
          fontWeight: '600',
          marginBottom: '32px',
        }}
      >
        基本设定
      </Box>
      <Box className="display-column-between" gap="32px 0">
        <Box sx={{ display: 'flex', gap: '0 48px' }}>
          <TextFieldCom
            sx={{ width: '330px' }}
            label="货架名称"
            showError={true}
            control={control}
            name="title"
            setValue={setValue}
            getValues={getValues}
            disabled={opt === OPT_DETAIL}
            rules={{
              required: true, //是否是必填项true 必填 false 非必填
              maxLength: 15,
            }}
            errors={errors}
          />
          <TextFieldCom
            sx={{ width: '330px' }}
            label="货架code"
            showError={true}
            control={control}
            name="code"
            setValue={setValue}
            getValues={getValues}
            disabled={opt === OPT_DETAIL}
            rules={{
              required: true, //是否是必填项true 必填 false 非必填
              maxLength: 25,
            }}
            errors={errors}
          />
        </Box>
        <Box>
          <Controller
            render={(pr) => (
              <UploadImageCom
                uW="150"
                uH="150"
                iW="150"
                iH="150"
                pr={pr}
                label={
                  <>
                    <span style={{ fontSize: '16px' }}>轮播图</span>
                    <span style={{ marginLeft: '6px', color: '#999999' }}>
                      建议尺寸750px*400px，最多上传10张，
                    </span>
                  </>
                }
                showSuccessNumber={true}
                disabled={opt === OPT_DETAIL}
                getValues={getValues}
                maxNumber="10"
                handlePreview={handlePreview}
                defaultValues={defaultValue?.images}
              />
            )}
            name="images"
            control={control}
          />
          <FormHelperText error={Boolean(errors.images)}>
            {errors.images && '请选择图片'}
          </FormHelperText>
          <Box>
            <RadioFieldCom
              typeList={DEFAULT_RADIO}
              control={control}
              name="isDefault"
              label="设为默认"
              defaultValue="0"
              disabled={opt === OPT_DETAIL}
              initLabel="设为默认"
              wrapStyle={{
                display: 'flex',
                gap: '0 12px',
                alignItems: 'center',
              }}
              labelStyle={{ marginBottom: 0 }}
              radioStyle={{ gap: '0' }}
              lWidth="70px"
            />
          </Box>
        </Box>
        <Box flex="1">
          <TextFieldCom
            label="兑换规则"
            showError={true}
            control={control}
            name="description"
            setValue={setValue}
            getValues={getValues}
            disabled={opt === OPT_DETAIL}
            rules={{
              required: true, //是否是必填项true 必填 false 非必填
              maxLength: 2000,
            }}
            errors={errors}
            multiline={true}
            maxRows="6"
            minRows="6"
            variant="outlined"
            textClassName="textField-area-wrap"
            placeholder="请输入"
          />
        </Box>
        <Box
          sx={{
            fontSize: '14px',
            color: '#333',
            background: '#F6F6F6',
            borderRadius: '8px',
            height: '40px',
            lineHeight: '40px',
            paddingLeft: '16px',
            marginTop: '-16px',
            marginBottom: '-8px',
          }}
        >
          <span style={{ color: '#999' }}>
            货架太阳码路径&nbsp;&nbsp;&nbsp;
          </span>{' '}
          {defaultValue?.sunCode}
        </Box>
        <Box>
          <Box
            sx={{
              color: '#212121',
              fontSize: '18px',
              fontWeight: '600',
              marginBottom: '18px',
            }}
          >
            兑换管控
          </Box>
          <Box>
            <CheckBoxFieldCom
              getValues={getValues}
              setValue={setValue}
              name="rule"
              control={control}
              checkedBoxList={CONTROL_RULES}
              disabled={opt === OPT_DETAIL}
              onCallBack={(checked) => {
                if (!checked.includes('1')) {
                  setValue('monthlyExchangeNum', '');
                }
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <TextFieldCom
                  sx={{ width: '110px' }}
                  label=""
                  control={control}
                  name="monthlyExchangeNum"
                  setValue={setValue}
                  getValues={getValues}
                  thousands={true}
                  isPositiveNumber={true}
                  isNumber={true}
                  disabled={opt === OPT_DETAIL}
                  errors={errors}
                  defaultValue="0"
                  isAdditionalRequired={!getValues('rule')}
                  initErrorText="必填项"
                  rules={{
                    max: getValues('rule') ? 999999 : '',
                    min: getValues('rule') ? 1 : '',
                    required: getValues('rule'),
                  }}
                />
                <span
                  style={{
                    color: 'rgba(0,0,0,0.87)',
                    fontSize: '16px',
                    marginLeft: '6px',
                  }}
                >
                  个礼品
                </span>
              </Box>
            </CheckBoxFieldCom>
          </Box>
          <Box>
            <CheckBoxFieldCom
              getValues={getValues}
              setValue={setValue}
              name="newMemberRule"
              control={control}
              checkedBoxList={NEW_MEMBER_CONTROL_RULES}
              disabled={opt === OPT_DETAIL}
              onCallBack={(checked) => {
                if (!checked.includes('1')) {
                  setValue('memberThresholdDay', '');
                }
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <TextFieldCom
                  sx={{ width: '110px' }}
                  label=""
                  control={control}
                  name="memberThresholdDay"
                  setValue={setValue}
                  getValues={getValues}
                  thousands={true}
                  isPositiveNumber={true}
                  isNumber={true}
                  disabled={opt === OPT_DETAIL}
                  errors={errors}
                  defaultValue="0"
                  isAdditionalRequired={!getValues('newMemberRule')}
                  initErrorText="必填项"
                  rules={{
                    max: getValues('newMemberRule') ? 999999 : '',
                    min: getValues('newMemberRule') ? 1 : '',
                    required: getValues('newMemberRule'),
                  }}
                />
                <span
                  style={{
                    color: 'rgba(0,0,0,0.87)',
                    fontSize: '16px',
                    marginLeft: '6px',
                  }}
                >
                  天内，视作新会员
                </span>
              </Box>
            </CheckBoxFieldCom>
          </Box>
        </Box>
        <GoodsShelfContent />
      </Box>

      <DialogMl onClose={handlePreviewClose} visible={previewOpen}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            alt=""
            src={previewUrl}
            style={{
              maxWidth: `${clientWidth * 0.6}px`,
              maxHeight: `${clientHeight * 0.6}px`,
              margin: 'auto',
            }}
          />
        </div>
      </DialogMl>
    </Box>
  );
};
